export const productDetails = {
  // Hero Section
  'productDetails.hero.title': 'How does',
  'productDetails.hero.titleHighlight': 'subvention360',
  'productDetails.hero.titleEnd': 'work?',
  'productDetails.hero.subtitle': 'A platform that centralizes available subsidies and facilitates the search for funding adapted to your profile',

  // Process Section
  'productDetails.process.title': 'Our process in 3 simple steps',

  // Step 1
  'productDetails.step1.title': 'Create your profile',
  'productDetails.step1.description': 'Enter your company information (SIRET, sector of activity, location). This data allows us to filter subsidies matching your eligibility criteria.',

  // Step 2
  'productDetails.step2.title': 'Discover opportunities',
  'productDetails.step2.description': 'Browse subsidies filtered according to your profile. Our database gathers French and European funding, regularly updated. Search by keyword, region or sector.',

  // Step 3
  'productDetails.step3.title': 'Access information',
  'productDetails.step3.description': 'View detailed information: eligibility criteria, amounts, deadlines, required documents and contact details of funding organizations. Access official application links.',

  // Features Section
  'productDetails.features.title': 'The features that make the difference',

  // Feature 1: Centralized Database
  'productDetails.feature1.title': 'Centralized Database',
  'productDetails.feature1.description': 'We gather French and European subsidies in a single platform, with their eligibility criteria, amounts and deadlines. Data is structured to facilitate your search.',
  'productDetails.feature1.point1': 'Regularly updated database',
  'productDetails.feature1.point2': 'Filtering by sector, region, type of aid',
  'productDetails.feature1.point3': 'Detailed information for each subsidy (amounts, deadlines, contacts)',

  // Feature 2: Advanced Search
  'productDetails.feature2.title': 'Advanced Search and Filtering',
  'productDetails.feature2.description': 'Quickly find relevant subsidies thanks to multiple search and filtering tools adapted to your specific needs.',
  'productDetails.feature2.point1': 'Keyword search (sector, project, type of aid)',
  'productDetails.feature2.point2': 'Filters by region, amount, deadline',
  'productDetails.feature2.point3': 'Sort by relevance or publication date',

  // Feature 3: Detailed Information
  'productDetails.feature3.title': 'Detailed Subsidy Information',
  'productDetails.feature3.description': 'For each funding opportunity, access essential information structured to facilitate your understanding and decision-making.',
  'productDetails.feature3.point1': 'Eligibility criteria (sector, company size, location)',
  'productDetails.feature3.point2': 'Available subsidy amounts and rates',
  'productDetails.feature3.point3': 'Application deadlines and required documents',
  'productDetails.feature3.point4': 'Contact details of funding organizations and link to official application',

  // Feature 4: Time Savings
  'productDetails.feature4.title': 'Time Savings in Research',
  'productDetails.feature4.description': 'Save time by avoiding browsing dozens of different websites. All information is centralized in one place.',
  'productDetails.feature4.point1': 'One place for all available subsidies',
  'productDetails.feature4.point2': 'Quick filtering according to your eligibility criteria',
  'productDetails.feature4.point3': 'Direct access to key information without navigating between multiple portals',

  // Feature 5: Multi-Source Coverage
  'productDetails.feature5.title': 'Multi-Source Coverage',
  'productDetails.feature5.description': 'Our database gathers subsidies from multiple official sources, national and European.',
  'productDetails.feature5.point1': 'French subsidies (regions, ADEME, BPI France, etc.)',
  'productDetails.feature5.point2': 'European subsidies (ERDF, ESF+, Horizon Europe, etc.)',
  'productDetails.feature5.point3': 'Sectoral aids and specific schemes regularly added',

  // Feature 6: Consultant Directory
  'productDetails.feature6.title': 'Expert Consultant Directory',
  'productDetails.feature6.description': 'Access a network of consultants specialized in subsidies to support you in your procedures if needed.',
  'productDetails.feature6.point1': 'Verified and qualified consultants by sector and region',
  'productDetails.feature6.point2': 'Search by specialization and geographic coverage',
  'productDetails.feature6.point3': 'Contact experts directly suited to your needs',

  // Who Is It For Section
  'productDetails.audience.title': 'Who is subvention360 for?',

  // Audience 1: Entrepreneurs
  'productDetails.audience1.title': 'Entrepreneurs & SMEs',
  'productDetails.audience1.description': 'Find investment, innovation and development funding adapted to your sector and region. Save time by consulting a centralized database.',

  // Audience 2: Associations
  'productDetails.audience2.title': 'Associations & NGOs',
  'productDetails.audience2.description': 'Identify subsidies for your cultural, social or environmental projects. Access eligibility criteria and funder contacts in one place.',

  // Audience 3: Consultants
  'productDetails.audience3.title': 'Consultants & Advisors',
  'productDetails.audience3.description': 'Use our database to advise your clients on available funding. Quickly access structured information to prepare your recommendations.',

  // Audience 4: Local Authorities
  'productDetails.audience4.title': 'Local Authorities',
  'productDetails.audience4.description': 'Browse European and national funding for your territorial projects (ecological transition, development, economic growth).',

  // Audience 5: Startups
  'productDetails.audience5.title': 'Startups & Scale-ups',
  'productDetails.audience5.description': 'Identify innovation, R&D and international development funding schemes available for young companies.',

  // Audience 6: Farmers
  'productDetails.audience6.title': 'Farmers',
  'productDetails.audience6.description': 'Access CAP aids, regional subsidies and agricultural transition schemes in a simplified interface.',

  // CTA Section
  'productDetails.cta.title': 'Start your subsidy search',
  'productDetails.cta.subtitle': 'Create your profile for free and discover the funding available for your project.',
  'productDetails.cta.createAccount': 'Create my account',
  'productDetails.cta.learnMore': 'Learn more'
} as const;
